export const HeatPumpQueryKeys = {
  all: ["heatpumps"] as const,
  findBrands: (query?: unknown) => [...HeatPumpQueryKeys.all, "brands", query] as const,
  findModels: (brandId?: unknown, query?: unknown) => [...HeatPumpQueryKeys.all, "models", brandId, query] as const,
  updateHeatPumpInSiteDeclaration: (siteId: number) =>
    [...HeatPumpQueryKeys.all, "update-heat-pump-in-site-declaration", siteId] as const,
  createModel: (query?: unknown) => [...HeatPumpQueryKeys.all, "create-heat-pump-model", query],
  createBrand: (query?: unknown) => [...HeatPumpQueryKeys.all, "create-heat-pump-brand", query],
};
